import { render, staticRenderFns } from "./VoucherManagement.vue?vue&type=template&id=60b9acbd&scoped=true"
import script from "./VoucherManagement.vue?vue&type=script&lang=js"
export * from "./VoucherManagement.vue?vue&type=script&lang=js"
import style0 from "./VoucherManagement.vue?vue&type=style&index=0&id=60b9acbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b9acbd",
  null
  
)

export default component.exports